import { useState, useCallback } from 'react';
import { backendClient } from '@/lib/api-client';
import { useMatterLabels } from '@/lib/useMatterLabels';
import { CategoryGroup, PromptResponse } from '../types';

export function useCustomPrompts(slug: string | undefined) {
  const label = useMatterLabels();
  const uncategorised = label('uncategorised');
  const [customGroups, setCustomGroups] = useState<CategoryGroup[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchCustomPrompts = useCallback(async () => {
    if (!slug) return;
    setIsLoading(true);
    try {
      const response = await backendClient.get(`/prompt-library/${slug}`);
      const prompts: PromptResponse[] = response.data;

      const grouped: Record<string, CategoryGroup> = {};
      for (const p of prompts) {
        const categoryName = p.category_name || uncategorised;
        if (!grouped[categoryName]) {
          grouped[categoryName] = {
            categoryKey: `custom-${categoryName}`,
            categoryName,
            prompts: [],
          };
        }
        grouped[categoryName].prompts.push({
          key: p.id,
          title: p.title,
          content: p.content,
          scope: p.scope,
          promptGroupId: p.prompt_group_id,
          categoryName,
          canManage: p.can_manage,
        });
      }
      setCustomGroups(Object.values(grouped));
    } catch (error) {
      console.error('Error fetching custom prompts:', error);
    } finally {
      setIsLoading(false);
    }
  }, [slug, uncategorised]);

  return { customGroups, isLoading, fetchCustomPrompts };
}
